import { render, staticRenderFns } from "./bulkUploadAssets.vue?vue&type=template&id=fb6a5dfe&scoped=true"
import script from "./bulkUploadAssets.vue?vue&type=script&lang=js"
export * from "./bulkUploadAssets.vue?vue&type=script&lang=js"
import style0 from "./bulkUploadAssets.vue?vue&type=style&index=0&id=fb6a5dfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6a5dfe",
  null
  
)

export default component.exports